import process from "process";
import { useQuery } from "react-query";
import { queryKeys } from "@/queries/queryKeys";
import axios from "axios";
import { NextSeo } from "next-seo";
import React from "react";
import LandingHeader from "@/components/Header/LandingHeader";
import GetInTouch from "@/components/ContactUs/GetInTouch";
import Location from "@/components/ContactUs/Location";
import Image from "next/image";
import Footer from "@/components/Footer/Footer";

export default function ContactUs() {
  const url = `https://api.storyblok.com/v2/cdn/stories/page/contact-us?token=${process.env.NEXT_PUBLIC_STORYBLOK_API_KEY}&version=published`;
  const { data, isLoading } = useQuery(queryKeys.contactUs, () =>
    axios.get(url)
  );
  const story = data?.data?.story?.content;
  const applyNowOptions = `https://api.storyblok.com/v2/cdn/stories/apply-now-options?token=${process.env.NEXT_PUBLIC_STORYBLOK_API_KEY}&version=published`;
  const { data: applyNowOptionsData, isLoading: isLoadingApplyNow } = useQuery(
    queryKeys.applyNowOptions,
    () => axios.get(applyNowOptions)
  );

  const applyNow = applyNowOptionsData?.data?.story?.content;
  return (
    <>
      <NextSeo
        title="Contact us"
        openGraph={{
          title: "Contact us",
          description: "",
        }}
      />
      {!isLoading && !isLoadingApplyNow && (
        <div className="landing relative overflow-hidden contact-us min-h-screen flex flex-col">
          <LandingHeader applyNowText={applyNow.apply_now_label} />
          <div className="land-container mt-0">
            <div className="lg:mt-12 lg:mb-12 md:mb-10 mb-6 md:mt-10 mt-6 flex md:flex-row flex-col items-start justify-between">
              <div className="md:w-[24%] w-full mg:max-w-[306px]">
                <GetInTouch
                  title={story.get_in_touch_title}
                  label={story.get_in_touch_label}
                  mailIcon={story.contact_mail_icon}
                  mail={story.contact_mail_title}
                  phoneIcon={story.contact_plone_icon}
                  phoneNumber={story.contact_number}
                  scheduleIcon={story.contact_schedule_icon}
                  schedule={story.contact_schedule_title}
                />
              </div>
              <div className="hor-line mb-6 mt-6 md:hidden block" />
              <div className="md:w-[24%] w-full mg:max-w-[306px]">
                <Location
                  title={story.location_title}
                  label={story.location_label}
                  locationIcon={story.location_icon}
                  locationAddress={story.location_address}
                  locationLink={story.location_link}
                />
              </div>
              <div className="lg:w-1/2 lg:max-w-full md:max-w-[456px] w-full md:mt-0 mt-6 md:mx-0 mx-auto">
                <Image
                  src={story.map_image + "/m/"}
                  width={100}
                  height={220}
                  alt={"map"}
                  className="w-full md:h-[220px] object-cover rounded-xl md:aspect-auto aspect-[16/6.5] "
                />
              </div>
            </div>
          </div>
          <Footer applyNowText={applyNow.apply_now_label} />
        </div>
      )}
    </>
  );
}
